export enum FormatType {
  WKT,
  GEOJSON
}
